module.exports = __webpack_public_path__ + "img/m.1474c31f.webp";